import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateUserConsent } from "../api";
import * as action from '../actions'
import Header from "../components/Header";
import "../styles/settings.css";
import timezoneListEnum from "../enum/timezone/timezoneList.enum";
import useToastify from "../hooks/useToastify";

export default function Settings() {
  const user = useSelector(state => state?.user)
  const dispatch = useDispatch();
  const agreement = useSelector(state => state?.user?.agreement)
  const {notifySuccess} = useToastify();

  const [timezone, setTimezone] = useState(user?.timezone);

  const resetAgreementCheck = () => {
    setTimezone(user?.timezone)
  }

  const saveAgreementUpdate = async () => {
    const payload = {
      privacyPolicy: agreement?.privacyPolicy,
      privacyPolicyAgreedOn: agreement?.privacyPolicyAgreedOn,
      useImagesForTrainning: agreement?.useImagesForTrainning,
      useImagesForTrainningAgreedOn: agreement?.useImagesForTrainningAgreedOn,
      consentForMarketing: agreement?.consentForMarketing,
      consentForMarketingAgreedOn: agreement?.consentForMarketingAgreedOn && null,
      timezone,
    };
    const updateUserConsentResp = await updateUserConsent(user.uid, payload);
    dispatch(action.updateUser({...user, ...updateUserConsentResp.user}));
    notifySuccess(updateUserConsentResp.message);
  }

  useEffect(() => {
    document.title = "Settings";
  }, []);

  return (
    <div className="container" data-testid="settings-container">
      <div className="main settings mt-3">
        <Header />
        <p className="heading">Settings</p>

        <div className="wrapper timezone-wrapper">
          <div className="select-timezone">
            <label className="label">Timezone</label>
            <select id="timezone" data-testid="timezone-option" name="timezone" className="custom-select" onChange={(e) => setTimezone(e.target.value)}>
              <option selected disabled={timezone}>
                {timezone}
              </option>
              {timezoneListEnum.map((timezone, index) => (
                <option key={index} selected={timezone === timezone.label} value={timezone}>
                  {timezone}
                </option>
              ))}
            </select>
          </div>
        </div>

        {(timezone !== user?.timezone) && (
          <div className="setting-cta">
            <div className="cancel-cta">
              <button className="cancel-cta-button" data-testid="cancel-cta-button" onClick={resetAgreementCheck}>
                Cancel
              </button>
            </div>
            <div className="save-cta">
              <button className="save-cta-button" data-testid="save-cta-button" onClick={saveAgreementUpdate}>
                Save
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
